import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { AxiosResponse } from "axios";
import http from "../../../../utils/http";
import { toastMessage, errorToastMessage } from "../../../../utils/toast";
import { LabelStyle } from "../../../Common/styles/form";
import {
  ModalBaseStyles,
  ModalHeader,
  ModalActionButtonStyles,
} from "../../../Common/styles/modal";
import { useParams } from "react-router-dom";

type Props = {
  openModal: boolean;
  data: any;
  closeModal: () => void;
  refreshPage: () => void;
};

const DeleteGroupModal = ({
  openModal,
  data,
  closeModal,
  refreshPage,
}: Props) => {
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const { id: studyId } = useParams();

  const submitHandler = async () => {
    try {
      setSubmitLoader(true);
      let res: AxiosResponse = await http.delete(
        `/study/${studyId}/participant-groups/${data?.id}?siteId=${data?.site}`
      );
      toastMessage("success", res.data.message);
      closeModal();
      refreshPage();
    } catch (err) {
      errorToastMessage(err as Error);
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={openModal} onClose={closeModal}>
      <Box
        sx={{
          ...ModalBaseStyles,
          "& .text-groupName": {
            color: "primary.main",
          },
          minHeight: "100px",
        }}
      >
        <ModalHeader title="Delete Cohort" onCloseClick={closeModal} />
        <Typography
          sx={{ ...LabelStyle, mb: 2 }}
          fontWeight={"medium"}
          variant="body1"
        >
          Are you sure you want to delete{" "}
          <span className="text-groupName">"{data?.groupName}"</span>
        </Typography>
        <Box sx={ModalActionButtonStyles}>
          {!submitLoader ? (
            <>
              <Button variant="outlined" onClick={closeModal}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" onClick={submitHandler}>
                Confirm
              </Button>
            </>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteGroupModal;
